import React from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import { COLORS, WEIGHT } from "theme";
import { useTranslation } from "react-i18next";

const FooterBox = ({ main, sec, ternary, isNumber, noHref }) => {
  const { t } = useTranslation();

  return (
    <Box background={COLORS.black}>
      <Text textColor={COLORS.white} fontWeight={WEIGHT.bold}>
        {t(main)}
      </Text>
      <Text textColor={COLORS.primary} fontSize={"14px"}>
        {noHref ? (
          t(sec)
        ) : (
          <a href={`${!isNumber ? `mailto:${sec}` : `tel:${sec}`}`}>{sec}</a>
        )}
      </Text>
      <Text textColor={COLORS.primary} fontSize={"14px"}>
        {t(ternary)}
      </Text>
    </Box>
  );
};

export default FooterBox;
